import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertAppraisalsMutationVariables = Types.Exact<{
  appraisals: Array<Types.Appraisals_Insert_Input> | Types.Appraisals_Insert_Input;
}>;


export type InsertAppraisalsMutation = { __typename?: 'mutation_root', insert_appraisals?: { __typename?: 'appraisals_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'appraisals', id: number }> } | null };


export const InsertAppraisalsDocument = gql`
    mutation insertAppraisals($appraisals: [appraisals_insert_input!]!) {
  insert_appraisals(objects: $appraisals) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export type InsertAppraisalsMutationFn = Apollo.MutationFunction<InsertAppraisalsMutation, InsertAppraisalsMutationVariables>;

/**
 * __useInsertAppraisalsMutation__
 *
 * To run a mutation, you first call `useInsertAppraisalsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertAppraisalsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertAppraisalsMutation, { data, loading, error }] = useInsertAppraisalsMutation({
 *   variables: {
 *      appraisals: // value for 'appraisals'
 *   },
 * });
 */
export function useInsertAppraisalsMutation(baseOptions?: Apollo.MutationHookOptions<InsertAppraisalsMutation, InsertAppraisalsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertAppraisalsMutation, InsertAppraisalsMutationVariables>(InsertAppraisalsDocument, options);
      }
export type InsertAppraisalsMutationHookResult = ReturnType<typeof useInsertAppraisalsMutation>;
export type InsertAppraisalsMutationResult = Apollo.MutationResult<InsertAppraisalsMutation>;
export type InsertAppraisalsMutationOptions = Apollo.BaseMutationOptions<InsertAppraisalsMutation, InsertAppraisalsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/appraisals/queries/insertAppraisals.mutation.gql}
 */
export async function insertAppraisals(
  variables: InsertAppraisalsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertAppraisalsMutation['insert_appraisals']>
export async function insertAppraisals(
  variables: InsertAppraisalsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertAppraisalsMutation>
export async function insertAppraisals(
  variables: InsertAppraisalsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertAppraisalsMutation['insert_appraisals'] | InsertAppraisalsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertAppraisalsMutation>(
    InsertAppraisalsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_appraisals
}